import { Box, Button, Grid, IconButton, Tooltip } from "@mui/material"
import { icons } from "../../../../../../utils/icons"
import { useStyles } from "./styles"
import { ActionProps } from "./types"
import { AnswerAction } from "./enum"
import { useTranslation } from "react-i18next"

const Actions = ({ click, haveConfig, disable, correct, isMultiple, downloadEvidences, isActiive, isCatalog, ...rest }: ActionProps) => {
    const styles = useStyles({ active: !!isActiive, isMultiple: isMultiple })
    const { t } = useTranslation()
    return (
        <Grid item xs={7}>
            <Box sx={styles.actions(!!isCatalog)}>
                <Box sx={[styles.item/* , ((!haveConfig?.residenceAlert ? styles.bigTextAndIcon:styles.normalTextAndIcon) as Object) */]}>
                    <Button sx={((!haveConfig?.evidence ? styles.bigTextAndIcon({active:correct}):'')as Object)} disabled={!haveConfig?.evidence} variant="text" onClick={() => { click({ name: AnswerAction.EVIDENCE }) }}>{!haveConfig?.evidence ? '-' : 'Ver'}</Button>

                    {!!haveConfig?.evidence && (
                        <Tooltip title={t('schedule.buttons.download')}>
                            <IconButton className="download" onClick={downloadEvidences} disabled={disable} sx={styles.disable({disable})}>
                                {icons('download')}
                            </IconButton>
                        </Tooltip>
                        )}
                </Box>

                <Button disabled={!haveConfig?.actionPlan} sx={[styles.item, styles.active({active:correct}), ((!haveConfig?.actionPlan ? styles.bigText:'') as Object)]} variant="text" onClick={() => { click({ name: AnswerAction.ACTION_PLAN }) }}>{!haveConfig?.actionPlan ? '-' : 'Ver'}</Button>

                <Button disabled={!haveConfig?.reportFolio} sx={[styles.item, styles.active({active:correct}), ((!haveConfig?.reportFolio ? styles.bigText:'') as Object)]} variant="text" onClick={() => { click({ name: AnswerAction.REPORT_FOLIO }) }}>{!haveConfig?.reportFolio ? '-' : 'Ver'}</Button>

                {!isCatalog && <Button disabled={!haveConfig?.residenceAlert} sx={[styles.item, styles.active({active:correct}), ((!haveConfig?.residenceAlert ? styles.bigText:'') as Object)]} variant="text" onClick={() => { click({ name: AnswerAction.RECOURRENCE_ALERT }) }}>{!haveConfig?.residenceAlert ? '-' : 'Ver'}</Button>}
            </Box>
        </Grid>
    )
}

export { Actions }
